import { Container, Link, Stack, Text } from "basis";
import { ScreenProps } from "components/StatementPreference/reducer/types";
import { CreditCard } from "../../CreditCard/CreditCard";

export const NoEmail = ({
  state: { accountInfo, personalDetails },
}: ScreenProps) => (
  <Stack gap="8">
    <Container bg="grey.t05" padding="4">
      <CreditCard
        cardName={accountInfo.cardName}
        cardEndsWith={accountInfo.cardEndsWith}
      />
    </Container>
    <Text as="h4" textStyle="heading4">
      You are currently receiving paper statements
    </Text>
    <Text>
      Your {accountInfo.cardName} statements are being send to{" "}
      {personalDetails?.address}.
      <br />
      <br />
      We don't have an email address for your {accountInfo.cardName}, it's how
      we send you notices when new online statements are ready. If you would
      like to switch to online statements, you can update your details on the{" "}
      <Link
        newTab
        href="https://latitudefs.zendesk.com/hc/en-au/articles/360007747097-Update-your-details"
      >
        Latitude website
      </Link>
      .
    </Text>
    <Link
      appearance="primary-button"
      variant="blue-button"
      width="216"
      href="/manage-account"
      newTab={false}
    >
      Manage account
    </Link>
  </Stack>
);
